export default "__VITE_ASSET__DzFN2g$z__"